import { useChatDialogWorkspace } from '@/entities/ChatDialog/model/workspace';
import { salebotDialogToTaskOrigin } from '../model/origins';
import { RelatedOperatorTasks } from './RelatedOperatorTasks';

/** Показывает задачи выбранного внешнего диалога */
export const SalesbotChatTasks = () => {
    const dialog = useChatDialogWorkspace((state) => state.selectedDialog);
    const origin = salebotDialogToTaskOrigin(dialog);

    if (!origin) return null;

    return <RelatedOperatorTasks
        origin={origin}
        variant="chat"
    />;
};
